export default __webpack_public_path__ + "static/media/postman.930ce66d.svg";